// services/adminSellFunnel.js

import axiosInstance from "api/axiosInstance";

// ============================
// 1.1 CREATE CRITERION
// ============================
export const createCriterion = async (data, accessToken) => {
    try {
        const response = await axiosInstance.post(
            "/admin/admin/funnel/criteria",
            data,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error(
            "Create criterion error:",
            error?.response?.data || error
        );
        throw error;
    }
};

// ============================
// 1.2 GET ALL CRITERIA
// ============================
export const getCriteria = async (accessToken) => {
    const response = await axiosInstance.get(
        "/admin/admin/funnel/criteria",
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    // داده‌ها در response.data.data قرار دارند
    return response.data.data || [];
};

// ============================
// 1.3 UPDATE DESCRIPTION/TITLE/STAGE_ORDER
// ============================
export const updateCriterionDescription = async (criterionId, data, accessToken) => {
    const response = await axiosInstance.patch(
        `/admin/admin/funnel/criteria/${criterionId}/description`,
        data,
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data;
};

// ============================
// 1.4 UPDATE PROMPT (AI TYPE)
// ============================
export const updateCriterionPrompt = async (criterionId, prompt, title, description, accessToken) => {
    const response = await axiosInstance.patch(
        `/admin/admin/funnel/criteria/${criterionId}/prompt`,
        {
            prompt: prompt,
            title: title,
            description: description

        },
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data;
};

// ============================
// 1.5 UPDATE RULE (SYSTEM_RULE TYPE)
// ============================
export const updateCriterionRule = async (criterionId, ruleConfig, title, description, accessToken) => {
    const response = await axiosInstance.patch(
        `/admin/admin/funnel/criteria/${criterionId}/rule`,
        {
            ruleConfig: ruleConfig,
            title: title,
            description: description
        },
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data;
};

// ============================
// 1.6 UPDATE VISIBILITY
// ============================
export const updateCriterionVisibility = async (criterionId, isVisible, accessToken) => {
    const response = await axiosInstance.patch(
        `/admin/admin/funnel/criteria/${criterionId}/visibility`,
        { isVisible },
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data;
};

// ============================
// 1.7 GET USAGE
// ============================
export const getCriterionUsage = async (criterionId, accessToken) => {
    const response = await axiosInstance.get(
        `/admin/admin/funnel/criteria/${criterionId}/usage`,
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data.data || response.data;
};

// ============================
// 1.8 DEACTIVATE CRITERION
// ============================
export const deactivateCriterion = async (criterionId, accessToken) => {
    const response = await axiosInstance.delete(
        `/admin/admin/funnel/criteria/${criterionId}/deactivate`,
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data;
};

// ============================
// 1.8.1 REACTIVATE CRITERION (فعال‌سازی مجدد)
// ============================
export const reactivateCriterion = async (criterionId, accessToken) => {
    const response = await axiosInstance.patch(
        `/admin/admin/funnel/criteria/${criterionId}/reactivate`,
        {},
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data;
};

// ============================
// 1.9 DELETE CRITERION (HARD DELETE)
// ============================
export const deleteCriterion = async (criterionId, accessToken) => {
    const response = await axiosInstance.delete(
        `/admin/admin/funnel/criteria/${criterionId}`,
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data;
};

// ============================
// SECTION 2: TEMPLATES
// ============================

// ============================
// 2.1 CREATE TEMPLATE
// ============================
export const createTemplate = async (data, accessToken) => {
    const response = await axiosInstance.post(
        "/admin/admin/funnel/templates",
        data,
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data;
};

// ============================
// 2.2 GET ALL TEMPLATES
// ============================
export const getTemplates = async (accessToken) => {
    const response = await axiosInstance.get(
        "/admin/admin/funnel/templates",
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data.data || [];
};

// ============================
// 2.3 UPDATE TEMPLATE (NAME/CATEGORY)
// ============================
export const updateTemplate = async (templateId, data, accessToken) => {
    const response = await axiosInstance.patch(
        `/admin/admin/funnel/templates/${templateId}`,
        data,
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data;
};

// ============================
// 2.4 UPDATE TEMPLATE STAGE
// ============================
export const updateTemplateStage = async (templateId, stageOrder, criterionId, accessToken) => {
    const response = await axiosInstance.patch(
        `/admin/admin/funnel/templates/${templateId}/stages/${stageOrder}`,
        { criterionId },
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data;
};

// ============================
// 2.5 SET TEMPLATE AS DEFAULT
// ============================
export const setTemplateAsDefault = async (templateId, accessToken) => {
    const response = await axiosInstance.patch(
        `/admin/admin/funnel/templates/${templateId}/default`,
        {},
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data;
};
// ============================
// 2.6 REACTIVATE TEMPLATE (فعال‌سازی مجدد)
// ============================
export const reactivateTemplate = async (templateId, accessToken) => {
    const response = await axiosInstance.patch(
        `/admin/admin/funnel/templates/${templateId}/reactivate`,
        {},
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data;
};

// ============================
// 2.6 DEACTIVATE TEMPLATE
// ============================
export const deactivateTemplate = async (templateId, accessToken) => {
    const response = await axiosInstance.delete(
        `/admin/admin/funnel/templates/${templateId}`,
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data;
};

// ============================
// 2.7 HARD DELETE TEMPLATE
// ============================
export const deleteTemplate = async (templateId, accessToken) => {
    const response = await axiosInstance.delete(
        `/admin/admin/funnel/templates/${templateId}/hard`,
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data;
};

// ============================
// 2.8 UPDATE STAGE NAMES (تغییر نام مراحل)
// ============================
export const updateStageNames = async (templateId, stages, accessToken) => {
    const response = await axiosInstance.patch(
        `/admin/admin/funnel/templates/${templateId}/stages`,
        { stages },
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data;
};
